import { type FC } from 'react';

import { Widget } from '@/components/Widget';
import { WithGap } from '@/components/WithGap';
import { useTexts } from '@/hooks/useTexts';
import { EsgExclusions } from '@/pages/Esg/widgets/EsgExclusions';

import { A4WidthForPrint } from '../components/A4WidthForPrint';
import { HeaderContainer } from '../components/HeaderContainer';
import { StyledStorebrandLogo } from '../components/StyledStorebrandLogo';

export const EsgExcludedCompanies: FC = () => {
  const texts = useTexts();

  return (
    <A4WidthForPrint>
      <WithGap data-test="esg-excluded-companies-screen">
        <HeaderContainer>
          <h1>{texts.pages.presentation.screens.esg.excludedCompanies}</h1>
          <StyledStorebrandLogo />
        </HeaderContainer>

        <Widget data-test="esg-exclusions-widget">
          <EsgExclusions />
        </Widget>
      </WithGap>
    </A4WidthForPrint>
  );
};
